export default "__VITE_ASSET__cb9029c9__"